<script setup>
  const props = defineProps({
    format: {
      type: String,
      default: 'code',
      validator: (value) => ['code', 'full'].includes(value)
    }
  })

  const { locale, locales } = useI18n()
  const { changeLocale } = useLanguages()
  const menu = ref()
  const items = ref([])
  for (const loc of locales.value) {
    items.value.push({
      label: loc.name,
      command: () => {
        changeLocale(loc.code)
      }
    })
  }

  const displayText = computed(() => {
    const currentLocale = locales.value.find(loc => loc.code === locale.value)
    return props.format === 'code' 
      ? currentLocale?.code.toUpperCase() 
      : currentLocale?.name
  })

  const toggle = (event) => {
    menu.value.toggle(event)
  }

  const selectLanguage = (localeCode) => {
    changeLocale(localeCode)
    menu.value.hide()
  }
</script>
<template>
  <Button
    type="button"
    variant="link"
    aria-haspopup="true"
    aria-controls="language_menu"
    pt:root="uppercase !text-xs !text-white hover:!text-sky-100 !h-8 !py-0"
    @click="toggle"
  >
    {{ displayText }}
  </Button>
  <Popover ref="menu" pt:root="!z-[1200]" pt:content="!p-0">
    <button
      v-for="loc in locales"
      :key="loc.code"
      class="block w-full py-2 px-4 capitalize text-left hover:!text-sky-800 cursor-pointer"
      @click="changeLocale(loc.code); menu.hide()"
    >
      {{ loc.name }}
    </button>
  </Popover>
</template>
